import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/app/store/authModule';
import { computed } from 'vue';
import { formatDate } from 'ah-common-lib/src/helpers/time';


export default /*#__PURE__*/_defineComponent({
  __name: 'LastLoginInfo',
  setup(__props) {

const authStore = useAuthStore();

const lastLoginTimestamp = computed(() => {
  if (authStore.lastLoginTimestamp) {
    return new Date(authStore.lastLoginTimestamp);
  }
  return null;
});

return { __sfc: true,authStore, lastLoginTimestamp, formatDate }
}

})